import { gql } from 'graphql-request';

export const PROGRAM_INSTANCE_QUERY = gql`
query ProgramInstance($id: ID!) {
  programInstance(id: $id) {
    id
    program {
      description
      displayName
      name
      iconUrl
    }
  }
}
`;
